module.exports = __webpack_public_path__ + "static/media/19ESCAP4.399f6b43.jpg";